export enum LegalDocumentsSegments {
    VIEW_PAGE_DEALER_DETAILS_COLLECTION = 'view_page_dealer_details_collection',
    TAP_BTN_SUBMIT = 'tap_btn_submit',
    TAP_BTN_TNC = 'tap_btn_t&c',
}
